var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}],staticClass:"global-loading",staticStyle:{"z-index":"9999"}},[_c('Spin',{attrs:{"size":"large"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }